import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { AlertCircle } from 'lucide-react';

interface DemoModeWarningModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSwitchToLive?: () => void;
}

export function DemoModeWarningModal({
  open,
  onOpenChange,
  onSwitchToLive,
}: DemoModeWarningModalProps): React.ReactElement {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <div className="flex items-center gap-2">
            <AlertCircle className="h-5 w-5 text-amber-500" />
            <DialogTitle>Demo Mode Active</DialogTitle>
          </div>
          <DialogDescription className="pt-2">
            You cannot create or edit transactions while in Demo Mode. 
            Please switch to Live Mode to perform this action.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex-col sm:flex-row gap-2">
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            className="w-full sm:w-auto"
          >
            Cancel
          </Button>
          {onSwitchToLive && (
            <Button
              onClick={() => {
                onSwitchToLive();
                onOpenChange(false);
              }}
              className="w-full sm:w-auto"
            >
              Switch to Live Mode
            </Button>
          )}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
